/** Strings of the admin pages. */
export const ca_admin = {
  adminUi: {
    tabs: {
      accounts: 'Comptes',
      invitations: 'Invitacions',
      players: 'Jugadors',
      integrations: 'Integracions',
      cba: 'Settings CBA',
      recipes: 'Receptes',
      catalog: 'Catàleg',
      activity: 'Activitat',
    },
    intros: {
      accounts:
        'Els comptes de la plataforma: qui pot entrar, amb quins rols, i les identitats que tenen enllaçades.',
      invitations:
        'Enllaços d’invitació. Cada un porta el seu codi i obre el registre a qui el rep; els pots retirar d’un en un sense tocar els altres.',
      players:
        'Els jugadors que el servidor ha vist en partida, pel seu identificador de Steam, i el compte a què estan enllaçats.',
      integrations:
        'Les portes d’entrada (Steam, Discord), el bot de Discord i què publica, i el panell de servidors.',
      cba: 'El cba_settings.sqf amb què es publica cada missió generada: els settings d’ACE, ACRE i la resta amb què juga el grup. En desar-lo es reescriu a totes les missions de les sessions obertes.',
      recipes:
        'L’estat de cada tipus de missió. La plataforma compta les fitxes de prova superades i proposa; l’estat només canvia quan el canvies tu.',
      catalog:
        'Les lectures del contingut dels mods, una per cada conjunt de mods que porta un servidor. Es llancen des del catàleg; aquí en veus l’estat.',
      activity: 'El registre del que ha passat a la plataforma: comptes, sessions, missions.',
    },
    recipes: {
      title: 'Receptes',
      loading: 'Carregant les receptes…',
      colRecipe: 'Recepta',
      colState: 'Estat',
      colProgress: 'Proves',
      colCards: 'Fitxes que calen',
      colNote: 'Nota',
      colDecided: 'Decidit',
      colActions: 'Accions',
      states: { ready: 'A punt', in_tests: 'En proves', coming: 'Properament' } as Record<
        string,
        string
      >,
      stateOf: (title: string) => `Estat de «${title}»`,
      cardsOf: (title: string) => `Fitxes que calen per a «${title}»`,
      noteOf: (title: string) => `Nota de «${title}»`,
      fixed: 'Encara no es pot generar: l’estat és fix.',
      progress: (passed: number, required: number, testers: number) =>
        `${passed} de ${required} fitxes superades · ${testers === 1 ? '1 provador' : `${testers} provadors`}`,
      failed: (n: number) =>
        n === 1 ? '1 fitxa amb un pas fallat' : `${n} fitxes amb un pas fallat`,
      proposal: { ready: 'Proposta: a punt', tests: 'Proposta: torna a proves' } as Record<
        string,
        string
      >,
      accept: { ready: 'Marca-la a punt', tests: 'Torna-la a proves' } as Record<string, string>,
      followsCode: 'Segueix el codi',
      decided: (by: string | null, when: string) => (by ? `${by} · ${when}` : when),
      save: 'Desa',
      saving: 'Desant…',
      cardsRange: 'Entre 0 i 20.',
      untied: (n: number) =>
        n === 1
          ? '1 fitxa tancada no porta cap missió i no compta per a cap recepta.'
          : `${n} fitxes tancades no porten cap missió i no compten per a cap recepta.`,
    },
    cba: {
      title: 'Settings de les missions generades',
      label: 'Contingut de cba_settings.sqf',
      hint: 'Enganxa aquí el fitxer sencer. Un «force» de la missió guanya el del servidor; el que no hi sigui es queda com el tingui el servidor. Buit vol dir cap fitxer.',
      lines: (n: number) => (n === 1 ? '1 línia de settings' : `${n} línies de settings`),
      none: 'Cap fitxer desat: les missions surten només amb les línies de Simplex.',
      savedAt: (when: string) => `Desat el ${when}`,
      save: 'Desa i aplica a les missions',
      saving: 'Desant…',
      saved: (republished: number) =>
        republished === 0
          ? 'Desat. Cap sessió oberta a reescriure; les missions noves ja el porten.'
          : republished === 1
            ? 'Desat i reescrit a la missió d’1 sessió oberta.'
            : `Desat i reescrit a les missions de ${republished} sessions obertes.`,
      cleared: 'Fitxer esborrat.',
    },
    search: 'Cerca per nom o usuari',
    colAccount: 'Compte',
    colRoles: 'Rols',
    colLastSeen: 'Vist per últim cop',
    colLastPlayed: 'Darrera partida',
    neverPlayed: 'cap partida',
    colState: 'Estat',
    colDetails: 'Detalls',
    active: 'actiu',
    anonymised: 'anonimitzat',
    expand: (handle: string) => `Detalls de @${handle}`,
    collapse: (handle: string) => `Amaga els detalls de @${handle}`,
    accountActions: 'Accions del compte',
    noAccountsMatch: 'Cap compte coincideix amb la cerca.',
    newAccountIntro:
      'Crea un compte amb usuari i primera contrasenya; dóna-la-hi en persona i que la canviï en entrar.',
    cancel: 'Cancel·la',
    colPlayer: 'Jugador',
    colUid: 'Identificador',
    colTimes: 'Vegades',
    colLinkedAccount: 'Compte enllaçat',
    colActions: 'Accions',
    noLinkedAccount: 'sense compte',
    doorsCard: 'Portes d’entrada',
    discordCard: 'Prova de sortida',
    discordCardIntro:
      'Envia un missatge de prova a cada canal configurat, pel bot o pel webhook, segons el que hi hagi.',
    serversCard: 'Servidors',
    serversCardIntro:
      'Les contrasenyes que la plataforma posa als servidors que crea al panell. Canviar-les aquí no toca els servidors ja creats.',
    serverAdminPassword: 'Contrasenya d’administració del servidor',
    serverAdminPasswordHint:
      'La que dóna les ordres d’administració dins la partida (#login). Només per a qui dirigeix la sessió.',
    serverPlayerPassword: 'Contrasenya per entrar-hi',
    serverPlayerPasswordHint:
      'La que la gent escriu per connectar-se al servidor. Deixa-la en blanc perquè el servidor sigui obert.',
    referenceServer: 'Servidor de referència',
    referenceServerHint:
      'Els servidors que crea la plataforma neixen amb la dificultat, la xarxa i les opcions d’aquest. Sense cap, agafa els valors per defecte del panell.',
    referenceServerNone: 'Cap: els valors per defecte del panell',
    passwordStored: 'N’hi ha una desada; deixa-ho en blanc per mantenir-la.',
    passwordUnset: 'Cap contrasenya desada.',
    panelCard: 'Panell de servidors',
    panelCardIntro:
      'El panell (ASM) on viuen els servidors. La plataforma el crida; ell no la crida mai.',
    panelCounts: (servers: number, running: number, max: number) =>
      `${servers} servidor${servers === 1 ? '' : 's'} d’Arma 3 al panell; ${running} de ${max} servidors gestionats en marxa.`,
    panelDetail: {
      answers: 'El panell respon',
      silent: 'El panell no respon',
      checking: 'Comprovant el panell…',
      lastAnswered: 'Darrera resposta',
      neverAnswered: 'Cap des que la plataforma ha arrencat',
      account: 'Compte de servei',
      accountUnknown: 'No es coneix',
      credentials: {
        credentials: 'entra amb usuari i contrasenya',
        token: 'entra amb un testimoni desat',
        none: 'sense credencials configurades',
      } as Record<string, string>,
      version: 'Versió',
      versionUnknown: 'El panell no la comunica',
      servers: 'Servidors que gestiona',
      noServers: 'Cap servidor d’Arma 3.',
      serversUnknown: 'No es poden llegir mentre el panell no respon.',
      access: {
        MANAGED: 'creat per la plataforma',
        LINKED: 'cedit a la plataforma',
        NONE: 'només lectura',
      } as Record<string, string>,
      operators: 'de l’operador',
      errors: 'Darrers errors',
      noErrors: 'Cap error recent.',
      recheck: 'Torna a comprovar',
      unavailable: 'No s’ha pogut comprovar l’estat del panell.',
    },
    inviteNew: 'Nova invitació',
    inviteNewIntro:
      'Genera un enllaç amb un codi únic. Copia’l i dóna’l a qui vulguis que es registri; el codi ja hi va posat.',
    inviteNote: 'Per a qui és',
    inviteNoteHint: 'Només perquè el reconeguis a la llista. Ho veuen els administradors.',
    inviteMaxUses: 'Registres que obre',
    inviteMaxUsesHint: '0 vol dir sense límit.',
    inviteExpiresIn: 'Caduca en (dies)',
    inviteExpiresInHint: 'Deixa-ho a 0 perquè no caduqui.',
    inviteCreate: 'Genera l’enllaç',
    inviteLink: 'Enllaç',
    inviteCopy: 'Copia l’enllaç',
    inviteCopied: 'Enllaç copiat.',
    inviteCopyFailed: 'No s’ha pogut copiar; selecciona l’enllaç i copia’l a mà.',
    inviteRevoke: 'Retira',
    inviteRevoked: 'retirada',
    inviteSpent: 'esgotada',
    inviteExpired: 'caducada',
    inviteActive: 'activa',
    inviteUses: (uses: number, max: number) =>
      max === 0 ? `${uses} registres` : `${uses} de ${max}`,
    inviteNever: 'no caduca',
    inviteNone: 'Encara no hi ha cap invitació.',
    colInviteFor: 'Per a qui',
    colInviteUses: 'Usos',
    colInviteExpires: 'Caducitat',
    colPreset: 'Servidor',
    colStarted: 'Iniciat',
    colError: 'Error',
    noActivity: 'Cap activitat registrada encara.',
    activityNobody: 'La plataforma',
    /** The activity log's own sentences, those the platform's cannot say because they name two people. */
    act: {
      someone: 'Algú',
      anAdmin: 'Un administrador',
      anAccount: 'un compte',
      unknownKind: 'Un altre tipus d’acció',
      unknown: 'ha fet una cosa que la plataforma encara no sap explicar',
      disabled: (target: string) => `ha desactivat el compte de ${target}`,
      enabled: (target: string) => `ha tornat a activar el compte de ${target}`,
      roleGranted: (role: string, target: string) => `ha donat el rol «${role}» a ${target}`,
      roleRevoked: (role: string, target: string) => `ha retirat el rol «${role}» a ${target}`,
      identityUnlinked: (provider: string, target: string) =>
        `ha desvinculat la identitat de ${provider} del compte de ${target}`,
      passwordReset: (handle: string) => `ha canviat la contrasenya de «${handle}»`,
      anonymised: (handle: string) => `ha anonimitzat el compte «${handle}»`,
      createdByAdmin: (handle: string) => `ha creat el compte «${handle}»`,
    },
    activityFilters: {
      account: 'Compte',
      allAccounts: 'Tots els comptes',
      kind: 'Tipus d’acció',
      allKinds: 'Tots els tipus',
      clear: 'Treure els filtres',
      aboutAccount:
        'Amb un compte triat, el registre mostra el que ha fet i el que li han fet a aquest compte.',
      none: 'Cap entrada amb aquests filtres.',
      older: 'Mostra’n d’anteriors',
      loading: 'Carregant…',
      shown: (n: number) => (n === 1 ? '1 entrada' : `${n} entrades`),
    },
    chunks: (got: number, expected: number | null) =>
      expected === null ? `${got} blocs` : `${got} de ${expected} blocs`,
  },
};
